<h1 class="title">
    <div>
        Estoque
        <span class="title-text-filter" (click)="setTitleTextFilter()" *ngIf="titleTextFilter">ativo <i class="fas icon fa-sort-down"></i></span>
        <span class="title-text-filter" (click)="setTitleTextFilter()" *ngIf="!titleTextFilter">inativo <i class="fas icon fa-sort-down"></i></span>
    </div>
    <div>
        <i [ngClass]="tableInfo == 'show-info' ? 'active' : ''" (click)="setTableShowInfo()" title="Exibir mais informações na tabela" class="fas fa-th-large icon-set-table-density"></i>
        <i [ngClass]="tableInfo == 'hide-info' ? 'active' : ''" (click)="setTableHideInfo()" title="Exibir menos informações na tabela" class="fas fa-th icon-set-table-density"></i>
        &nbsp;
        <i class="fas fa-plus-circle icon-title" routerLink="/admin/veiculo/"></i>
    </div>
</h1>
<div class="vehicle-list {{tableInfo}}">
    <div class="vehicle-list-filters hidden">
        filtrar por marca | ativo | valor | data cadastro
        <i class="fas fa-search push-right"></i>
    </div>
    <ng-container *ngIf="filteredVehicleList.length > 0">
        <ng-container *ngFor="let v of filteredVehicleList">
            <div [ngClass]="[v.VehicleStatus == 'Inativo' ? 'inactive' : '', v.VehicleStatus == 'Vendido'? 'sold' : '', v.Feature ? 'feature' : '']" class="vehicle" routerLink="/admin/veiculo/{{v.IdVehicle}}">
                <span *ngIf="v.Feature" class="lbl-sticker feature">destaque</span>
                <img class="vehicle-img" src="{{v.FeatureImage}}" alt="Imagem principal" />
                <div class="main-info">
                    <div>
                        <label class="name">{{v.Name}}</label><br />
                        <label class="model">{{v.Model}}</label>
                    </div>
                    <b *ngIf="v.VehicleStatus == 'Ativo'" class="status"><i class="icon fad fa-check-circle"></i>&nbsp;&nbsp;Ativo</b>
                    <b *ngIf="v.VehicleStatus == 'Inativo'" class="status color-orange"><i class="icon fas fa-ban"></i>&nbsp;&nbsp;Inativo</b>
                    <b *ngIf="v.VehicleStatus == 'Vendido'" class="status"><i class="icon fad fa-check-circle"></i>&nbsp;&nbsp;Vendido</b>
                    <span class="balance">
                        <label class="lbl">Lucro</label>
                        R$ {{v.SaleValue - v.CostPrice | number}}
                    </span>
                </div>
                <div class="details">
                    <div>
                        <label class="lbl">Código</label>
                        <label class="value">{{v.IdVehicle}}</label>
                    </div>
                    <div>
                        <label class="lbl">Fabricante</label>
                        <label class="value">{{v.Manufacturer}}</label>
                    </div>
                    <div>
                        <label class="lbl">Ano</label>
                        <label class="value">{{v.Year}}</label>
                    </div>
                    <div>
                        <label class="lbl">Km</label>
                        <label class="value">{{v.Km}}</label>
                    </div>
                    <div>
                        <label class="lbl">Câmbio</label>
                        <label class="value">{{v.Gearbox}}</label>
                    </div>
                    <div>
                        <label class="lbl">Combustível</label>
                        <label class="value">{{v.Fuel}}</label>
                    </div>
                    <div>
                        <label class="lbl">Cor</label>
                        <label class="value">{{v.Color}}</label>
                    </div>
                    <div>
                        <label class="lbl">Final da placa</label>
                        <label class="value">{{v.LicensePlate}}</label>
                    </div>
                    <div>
                        <label class="lbl">Cadastro</label>
                        <label class="value">{{v.CreationDate}}</label>
                    </div>
                </div>
                <div class="price">
                    <span class="cost">R$ {{v.CostPrice | number}}</span>
                    <span class="sale">R$ {{v.SaleValue | number}}</span>
                </div>
            </div>
            <br />
            <br />
        </ng-container>
        <label class="lbl-count">
            {{ filteredVehicleList.length }} veículo<ng-container *ngIf="filteredVehicleList.length > 1">s</ng-container>
        </label>
    </ng-container>
    <ng-container *ngIf="filteredVehicleList.length == 0">
        <h3 class="cursor-pointer" routerLink="/admin/veiculo/">Nenhum veículo para ser exibido.<br />Clique aqui para cadastrar um veículo.</h3>
    </ng-container>
</div>
<br />
<br />
<br />